import { useEffect, useRef } from "react";

const WS_URL = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws") + "/api/ws";

export const emitSync = (detail) => window.dispatchEvent(new CustomEvent("ks-sync", { detail }));

export const useLive = (query, onEvent) => {
  const cb = useRef(onEvent);
  cb.current = onEvent;
  const key = query ? new URLSearchParams(query).toString() : "";
  useEffect(() => {
    if (!key) return;
    let ws, ping, retry, stop = false, delay = 1000, opened = false;
    const open = () => {
      ws = new WebSocket(`${WS_URL}?${key}`);
      ws.onopen = () => {
        delay = 1000;
        if (opened) cb.current({ event: "sync", data: { reconnected: true } });
        opened = true;
        ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000);
      };
      ws.onmessage = (m) => {
        try { const e = JSON.parse(m.data); if (e.event !== "pong" && e.event !== "hello") cb.current(e); } catch { /* ignore */ }
      };
      ws.onclose = (e) => {
        clearInterval(ping);
        if (stop || e.code === 4401) return;
        retry = setTimeout(open, delay);
        delay = Math.min(delay * 2, 30000);
      };
    };
    open();
    const wake = () => {
      if (document.visibilityState !== "visible" || stop) return;
      if (!ws || ws.readyState > 1) { clearTimeout(retry); delay = 1000; open(); }
      cb.current({ event: "sync", data: { wake: true } });
    };
    document.addEventListener("visibilitychange", wake);
    window.addEventListener("online", wake);
    return () => { stop = true; clearInterval(ping); clearTimeout(retry); document.removeEventListener("visibilitychange", wake); window.removeEventListener("online", wake); ws && ws.close(); };
  }, [key]);
};

export const useSync = (fn) => {
  const r = useRef(fn);
  r.current = fn;
  useEffect(() => {
    let t;
    const h = () => { clearTimeout(t); t = setTimeout(() => r.current(), 300); };
    window.addEventListener("ks-sync", h);
    return () => { window.removeEventListener("ks-sync", h); clearTimeout(t); };
  }, []);
};
